import React from "react";

// set the defaults
const FilterContext = React.createContext({});

export default FilterContext;
